import React from "react";
import { GoPlus } from "react-icons/go";

const MasterButton = ({
  buttonName,
  onClick,
  width,
  plus,
  type = "button",
  disabled = false,
}) => {
  return (
    <div className="btn_shadow">
      <button
        type={type}                
        disabled={disabled}       
        onClick={disabled ? undefined : onClick} 
        className={`${width} masterButton`}
      >
        {plus && <GoPlus size={20} />}{" "}
        { buttonName}
      </button>
    </div>
  );
};

export default MasterButton;
